import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invitation-page',
  templateUrl: './invitation-page.component.html',
  styleUrls: ['./invitation-page.component.scss']
})
export class InvitationPageComponent implements OnInit {
  inviteForm:FormGroup
  errorMsg: string;
  currentDate = new Date().getFullYear()

  constructor(private fb:FormBuilder, private router:Router) { }

  ngOnInit(): void {
    this.inviteForm = this.fb.group({
      'password':['', Validators.required],
      'confirm':['', Validators.required]
    })
  }

}
